import type { ComputedRef, InjectionKey } from 'vue'
import type { FormField } from '../gat-form-field/useFormField'
import type { FormValidationResult, ValidateOptions } from './gat-form.vue'

export interface FormContext<TValue> {
  isProvided: boolean
  fieldType: 'default' | 'inset'
  readonly: boolean
  formName?: string
  registerField: (field: FormField<TValue>) => void
  unregisterField: (id: string) => void
  validateAllFields: (options?: {
    onlyDirty?: boolean
  }) => Promise<{ valid: boolean; errors: Record<string, string> }>
  resetAllFields: () => void
  getField: (id: string) => FormField<TValue> | undefined
  getAllFields: () => FormField<TValue>[]
  markFieldDirty: (id: string) => void
  validate: (options?: ValidateOptions) => Promise<FormValidationResult>
  resetValidation: () => void
  setAiValues: (values: Record<string, any>) => void
  setErrorMessage: (errorMessage: string) => void
  errorMessage: ComputedRef<string | undefined>
}

export const GAT_FORM_CONTEXT_KEY = Symbol('gat-form-context') as InjectionKey<
  FormContext<any>
>
